import { Component, input } from '@angular/core';
import { RemoveHtmlPipe } from '@shared/pipes/remove-html.pipe';
import { HelperService } from '../../../../../../services/helper.service';
import { E_DATE_FORMAT } from '@shared/constants/enums.const';

@Component({
  selector: 'app-latest-meeting-card',
  imports: [
    RemoveHtmlPipe,

  ],
  templateUrl: './latest-meeting-card.component.html',
  styleUrl: './latest-meeting-card.component.scss',
})
export class LatestMeetingCardComponent {
  from = input.required<string>();
  to = input.required<string>();
  title = input.required<string>();
  description = input.required<string>();
  protected readonly E_DATE_FORMAT = E_DATE_FORMAT;

  constructor(public HELPER: HelperService) {}
}
